export const optionsRole = [
   { name: 'user', value: 'user'},
   { name: 'admin', value: 'admin'},
  ];

export const optionsAccountStatus = [
    { name: 'active', value: true},
    { name: 'deActive', value: false},
  ];